import { BatchJobType } from '@/types/batch';
import { parseServerTime } from '@/lib/serverTime';

// BE BatchJobType#stuckThreshold()와 같은 기준이어야 한다 - 이 시간을 넘긴 RUNNING 이력은 서버의
// "오래된 RUNNING 배치 정리"가 FAILED로 바꾸므로 화면에서도 그때부터 비정상으로 표시한다.
// 마케팅 아웃리치는 정상 실행이 10~30분이라 5분 기준이면 정상 실행이 "비정상"으로 보였다(2026-10-01).
export const getStuckThresholdMinutes = (jobType: BatchJobType): number =>
  jobType === 'MARKETING_OUTREACH_DAILY' ? 60 : 5;

export const isStuckRunning = (startedAt: string, jobType: BatchJobType, now: Date = new Date()): boolean => {
  const start = parseServerTime(startedAt);
  if (!start) return false;
  return (now.getTime() - start.getTime()) / 60000 > getStuckThresholdMinutes(jobType);
};
